import React, { useState, useEffect, useContext } from "react"
import { Container, Grid, Stack, Button, Typography, Box, Accordion, AccordionSummary, AccordionDetails } from "@mui/material"
import { SentimentVeryDissatisfied, ExpandMore, Home, PictureAsPdf } from "@mui/icons-material"
import { useResultado } from "../hooks/useResultado.jsx"
import { useColors } from '../hooks/useColors'
import { useTools } from '../hooks/useTools'
import { ResultadoContext } from "../context/ResultadoContext"
import { GeneralContext } from "../context/GeneralContext"
import { RadarChart } from "../components/Radar.jsx"
import LoadingButton from '@mui/lab/LoadingButton'
import '../styles/Resultado.css';
import { useSecurity } from "../hooks/useSecurity"
import { useTranslation } from "react-i18next"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Parser from 'html-react-parser';
import Modal from "../components/commons/Modal.jsx"
import { Leyenda } from "../components/Leyenda.jsx"
import colors from "../theme/colors.jsx"
import InfoIcon from '@mui/icons-material/Info';
import { CalificationWithImageAndText } from "../components/commons/CalificationWithImageAndText.jsx"


export function Resultado() {
    const { user, navigate, cuestionarioID, setChartImage } = useContext(GeneralContext)
    const { GetCuestionarioReport, loading, setLoading } = useContext(ResultadoContext)
    const { getResultadoByCuestionario } = useResultado()
    const [expanded, setExpanded] = useState("panel")
    const [showInfoModal, setShowInfoModal] = useState(false)
    const [temasMasRecomendaciones, settemasMasRecomendaciones] = useState(null)
    useSecurity()
    const { getCalificationColor } = useColors()
    const { t } = useTranslation()
    const { scrollToElement } = useTools()

    useEffect(() => {
        if (!cuestionarioID) navigate("/MisCuestionarios")
        if (user) GetResultado()
    }, [user]);

    function GetResultado() {
        getResultadoByCuestionario(cuestionarioID, user).then(
            (resultado) => {
                settemasMasRecomendaciones(resultado)
            },
            (y) => {
                console.error("Error: " + y)
            }
        );
    }

    function Comenzar() {
        navigate("/MisCuestionarios");
    }

    const dotColor = (calification) => {
        switch (calification) {
            case "A":
                return "aDot"
            case "B":
                return "bDot"
            case "C":
                return "cDot"
            case "D":
                return "dDot"
            default:
                break

        }
    }

    const handleShowInfoModal = () => {
        setShowInfoModal(true)
    }

    const handleChangePanel = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const handleChangeAccordion = (event, expanded) => {
        event.preventDefault();
    }
    return (
        <>
            {temasMasRecomendaciones && (
                <Stack spacing={1} marginY="2em" direction="column" height="100%">
                    <Accordion
                        expanded={expanded === "panel"}
                        onChange={handleChangePanel("panel")}
                    >
                        <AccordionSummary
                            sx={{
                                color: colors.parrafoLight,
                                backgroundColor: colors.bgPrimaryLight,
                                borderRadius: '10px 10px 10px 10px'
                            }}
                            expandIcon={<ExpandMore sx={{ fontSize: "2.5rem", color: colors.parrafoLight }} />}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Grid item>
                                    <Typography
                                        align="left"
                                        variant="h2"
                                        fontWeight="bold"
                                        margin='0'
                                        color={colors.parrafoLight}
                                    >
                                        {t("Resultado.resumen")}
                                    </Typography>

                                </Grid>
                                <Grid item sx={{ marginTop: { xs: '1rem', md: '0' }, backgroundColor: colors.textLink, padding: '1rem', borderRadius: '2rem' }}>
                                    {temasMasRecomendaciones ? (
                                        <Box>
                                            {temasMasRecomendaciones.calificacion ? (
                                                <CalificationWithImageAndText calification={temasMasRecomendaciones.calificacion} width={96} />
                                            ) : (
                                                <SentimentVeryDissatisfied
                                                    style={{ color: "red" }}
                                                    fontSize="large"
                                                />
                                            )}
                                        </Box>
                                    ) : (
                                        ""
                                    )}
                                </Grid>
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Stack direction="row" justifyContent="space-between" spacing={6} padding={3} >
                                <Leyenda />
                                <InfoIcon onClick={handleShowInfoModal} cursor={'pointer'} fontSize={'large'} />
                            </Stack>
                            {temasMasRecomendaciones.puntuacionEje?.length >= 3 ? (
                                <Box sx={{ height: { xs: 'auto', md: '550px' }, display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
                                    <RadarChart puntuacionesEjes={temasMasRecomendaciones.puntuacionEje} calification={temasMasRecomendaciones.calificacion} />
                                </Box>
                            ) :
                                (
                                    setChartImage()
                                )}
                            {temasMasRecomendaciones ? (
                                temasMasRecomendaciones.puntuacionEje?.map((resumen, index) => (
                                    <Stack justifyContent={"center"}
                                        sx={{
                                            p: 1,
                                            borderRadius: "10px",
                                        }}
                                        key={index}
                                    >


                                        <Stack
                                            direction="row"
                                            justifyContent={{xs: 'center', lg: 'space-between'}}
                                            alignItems="center"
                                            spacing={1}
                                        >
                                            <Box>
                                                <Typography variant='h3' fontWeight={"bold"}>
                                                    {resumen.eje.texto}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                {resumen.calificacion ? (
                                                    <CalificationWithImageAndText calification={resumen.calificacion} width={64} />
                                                ) : (
                                                    <SentimentVeryDissatisfied
                                                        style={{ color: "red" }}
                                                        fontSize="large"
                                                    />
                                                )}
                                            </Box>
                                        </Stack>
                                        <Grid item xs={2} sm={1} md={1} lg={1}>
                                            <Accordion
                                                id={"accordion" + index}
                                                defaultExpanded={true}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel2a-content"
                                                >
                                                    <Typography variant="h4" gutterBottom>{t("Resultado.recomendaciones")}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails
                                                >
                                                    {resumen?.recomendaciones?.map((recomendaciones, index) => (
                                                        <Stack
                                                            direction="row"
                                                            alignItems="center"
                                                            spacing={1}
                                                            key={index}
                                                            marginBottom='1em'
                                                        >
                                                            <Box className="dotContainer">
                                                                <Box className={dotColor(recomendaciones.calificacion)}></Box>
                                                            </Box>
                                                            <Typography variant="parrafo">
                                                                {Parser(recomendaciones.recomendacion)}
                                                            </Typography>
                                                        </Stack>
                                                    ))}

                                                    <Typography variant="caption" color={colors.error}>{t("Resultado.advertencia")}</Typography>

                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Stack>
                                ))
                            ) : (
                                <div>Error</div>
                            )}
                        </AccordionDetails>
                    </Accordion>

                    <Box className="botones">
                        <Grid container direction="row" justifyContent="space-between">
                            <Grid item>
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        Comenzar()
                                    }}
                                    endIcon={<Home sx={{ color: colors.textMain }} />}
                                    size="large"
                                >
                                    {t("eje.btnVolver")}
                                </Button>
                            </Grid>
                            {/* Boton PDF */}
                            <Grid item>
                                <LoadingButton
                                    onClick={() => {
                                        setLoading(true);
                                        GetCuestionarioReport();
                                    }}
                                    loading={loading}
                                    variant="contained"
                                    endIcon={<PictureAsPdf sx={{ color: colors.textMain }} />}
                                    size="large"
                                    loadingPosition="end"
                                >
                                    {t("Resultado.BotonPDF")}
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </Box>
                    <Modal title={t("cuestion.tituloDescripcionEtapas")} content={t("cuestion.bodyDescripcionEtapas")} open={showInfoModal}>
                        <Button variant="contained" onClick={() => { setShowInfoModal(false) }} >{t("general.aceptar")}</Button>
                    </Modal>
                </Stack>
            )}
        </>
    );
}
